import React from 'react';
import { Image } from 'gql/autogen/Image';
import { Box, ObjectFit } from '@drone-js/core';
import styled from 'styled-components';
import CarouselImage from 'component/page/detail/DetailCard/ActivityCarousel/ActivityCarouselImage';
import { StringFormatter } from '@agoda/react-handyman';
import { useSelector } from 'react-redux';
import { selectCmsFromBootstrap } from 'store/slice/bootstrap';

const BlurDroneImage = styled(Box)`
    filter: blur(15px);
    transform: scale(1.1);
`;
interface Props {
    image: Image;
    onLoad?: Function;
    isMosaicEnabled?: boolean;
    imageIndex: number;
    totalImages: number;
    objectFit?: ObjectFit;
    height?: string;
}

const MainImage: React.FC<Props> = React.memo((props) => {
    const cms = useSelector(selectCmsFromBootstrap);
    return (
        <Box data-testid="activities-carousel-image" position="relative" overflow="hidden" height="450px">
            <BlurDroneImage position="absolute" width="100%" height={props.height}>
                <CarouselImage
                    image={props.image}
                    imageIndex={props.imageIndex}
                    totalImages={props.totalImages}
                    onLoad={props.onLoad}
                    isMosaicEnabled={props.isMosaicEnabled}
                    objectFit="cover"
                    height={props.height}
                />
            </BlurDroneImage>
            <Box position="relative" height={props.height}>
                <CarouselImage
                    image={props.image}
                    imageIndex={props.imageIndex}
                    totalImages={props.totalImages}
                    onLoad={props.onLoad}
                    isMosaicEnabled={props.isMosaicEnabled}
                    alt={StringFormatter.format(cms[321481], props.imageIndex, props.totalImages)}
                    objectFit="contain"
                    height={props.height}
                />
            </Box>
        </Box>
    );
});
MainImage.displayName = 'MainImage';

export default MainImage;
